<astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
  <astral-checkbox [control]="negotiatingClause"></astral-checkbox>
  <astral-select [control]="organizationOfTenants" [itemsSource]="itemsSource"></astral-select>
  @if (organizationOfTenants.value == 2) {
    <astral-input [control]="otherOrganizationOfTenants"></astral-input>
  }
</astral-layout-group>
